let replyChimeContext: AudioContext | null = null;
let hasPrimedReplyChime = false;

const getReplyChimeContext = () => {
  if (typeof window === "undefined") return null;

  const Ctx =
    window.AudioContext ||
    (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;

  if (!Ctx) return null;
  if (!replyChimeContext || replyChimeContext.state === "closed") {
    replyChimeContext = new Ctx();
  }

  return replyChimeContext;
};

const playChimeNotes = (ctx: AudioContext) => {
  const now = ctx.currentTime;
  const notes = [880, 1320];

  notes.forEach((freq, i) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = "sine";
    osc.frequency.value = freq;

    const start = now + i * 0.12;
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.18, start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.32);

    osc.connect(gain).connect(ctx.destination);
    osc.start(start);
    osc.stop(start + 0.34);
  });
};

const unlockReplyChime = () => {
  const ctx = getReplyChimeContext();
  if (!ctx) return;

  if (ctx.state === "suspended") {
    void ctx.resume().catch(() => {});
  }
};

export const primeReplyChime = () => {
  if (typeof window === "undefined" || hasPrimedReplyChime) return;
  hasPrimedReplyChime = true;

  const handleFirstGesture = () => {
    unlockReplyChime();
  };

  window.addEventListener("pointerdown", handleFirstGesture, { once: true, passive: true });
  window.addEventListener("keydown", handleFirstGesture, { once: true, passive: true });
  window.addEventListener("touchstart", handleFirstGesture, { once: true, passive: true });
};

export const playReplyChime = () => {
  try {
    const ctx = getReplyChimeContext();
    if (!ctx) return;

    if (ctx.state === "running") {
      playChimeNotes(ctx);
      return;
    }

    if (ctx.state === "suspended") {
      void ctx.resume().then(() => {
        if (ctx.state === "running") {
          playChimeNotes(ctx);
        }
      }).catch(() => {});
    }
  } catch {
    // ignore - audio is non-essential
  }
};
